// extracted by mini-css-extract-plugin
module.exports = {"container":"Hy","productName":"Iy","modal":"Jy","dimensions":"Ky","recipientEmail":"Ly","lowStock":"My","recommendedFit":"Ny"};